import { InjectionToken } from '@angular/core';

const TENANT_KEY_RX = /^\/([a-z0-9-]+:\d+)/i; // EX: organization:123, some-thing:456, thing-v2:123

export const TENANT_KEY = new InjectionToken<string | undefined>('tenantKey', {
  providedIn: 'root',
  factory: () => (window.location.pathname.match(TENANT_KEY_RX) || [])[1] || undefined
});
